// eslint-disable-next-line
const { createStore } = require('/Users/shimono/Documents/Work/git/fism/affinity-dashboard-frontend/.nuxt/store');
// eslint-disable-next-line
const { getAccessorFromStore } = require('/Users/shimono/Documents/Work/git/fism/affinity-dashboard-frontend/node_modules/nuxt-typed-vuex/lib/utils');
const storeAccessor = getAccessorFromStore(createStore());
export default async ({ store }, inject) => {
    inject('accessor', storeAccessor(store));
};
//# sourceMappingURL=plugin.js.map